if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));

      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');

      if (document.querySelector('cart-drawer')) {
        this.submitButton.setAttribute('aria-haspopup', 'dialog');
      }
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

  this.submitButton.setAttribute('aria-disabled', true);
this.submitButton.classList.add('loading');
this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

document.dispatchEvent(new CustomEvent('td:product-form:submit-start', {
  detail: { formId: this.form.id }
}));

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      const selectedVariantId = formData.get('id');

      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }

      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            this.error = true;

            document.dispatchEvent(new CustomEvent('td:product-form:submit-error', {
              detail: { formId: this.form.id, message: response.description }
            }));

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;

          this.submitButton.setAttribute('aria-disabled', true);
this.submitButton.querySelector('span').classList.add('hidden');
soldOutMessage.classList.remove('hidden');
this.error = true;
return;
          }

          this.error = false;
if (!this.cart) {
  window.location.href = routes.cart_url;
  return;
}
document.dispatchEvent(new CustomEvent('td:product-form:submit-success', {
  detail: { formId: this.form.id, response }
}));

          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener(
              'modalClosed',
              () => {
                setTimeout(() => {
                  this.cart.renderContents(response);
                });
              },
              { once: true }
            );
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
     .catch((e) => {
  console.error(e);
  document.dispatchEvent(new CustomEvent('td:product-form:submit-error', {
    detail: { formId: this.form.id, error: e }
  }));
})
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) {
            this.cart.classList.remove('is-empty');
          }
          if (!this.error || !this.submitButton.querySelector('.sold-out-message')) {
            this.submitButton.removeAttribute('aria-disabled');
          }
         this.querySelector('.loading-overlay__spinner').classList.add('hidden');

document.dispatchEvent(new CustomEvent('td:product-form:submit-end', {
  detail: { formId: this.form.id, hasError: !!this.error }
}));
        });
    }

    updateCartBubble() {
      fetch(`${routes.cart_url}.js`)
        .then((response) => response.json())
        .then((cart) => {
          const bubbleLink = document.getElementById('cart-icon-bubble');
          if (!bubbleLink) return;

          let bubble = bubbleLink.querySelector('.cart-count-bubble');

          if (cart.item_count > 0) {
            if (!bubble) {
              bubble = document.createElement('div');
              bubble.className = 'cart-count-bubble';
              bubble.innerHTML = '<span aria-hidden="true"></span><span class="visually-hidden"></span>';
              bubbleLink.appendChild(bubble);
            }

            const visible = bubble.querySelector('span[aria-hidden="true"]');
            const sr = bubble.querySelector('.visually-hidden');

            if (visible) {
              visible.textContent = cart.item_count < 100 ? cart.item_count : '';
            }

            if (sr) {
              sr.textContent = String(cart.item_count);
            }
          } else if (bubble) {
            bubble.remove();
          }
        })
        .catch((e) => {
          console.error(e);
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper =
        this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;

      this.errorMessage =
        this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
